import React from 'react';

import {Pagination} from '../../com/pagination';
import {Actions} from '../actions';
import {useDispatch, useSelector} from 'react-redux';
import {IAppState} from '../../store/models';
import {ReactComponent as ChevronLeft} from '../../assets/icons/chevron-left.svg';
import {ReactComponent as ChevronRight} from '../../assets/icons/chevron-right.svg';
import {IFlyerRuntime} from '../../dtos/flyer';
import {zoomIn} from '../../store/actionsCreator/zoomActionCreators';
import {Box, Button, Grid, Typography} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {openUrlInAnotherTab} from "../../com/globalsFunctions/globalFunctions";
import tinycolor from "tinycolor2";

const useStyles = makeStyles(() => ({
    desktopHeaderBox: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        maxWidth: `100%`,
        height: '100%'
    },
    desktopHeaderWrapper: (props: any) => ({
        backgroundColor: props.primaryColor,
        direction: props.direction,
        '& .MuiTypography-root': {
            fontFamily: props.fontFamily,
            textOverflow: `ellipsis`,
            overflow: `hidden`,
            whiteSpace: `nowrap`,
            maxWidth: `100%`,
            color: props.isLightGuiColor ? props.fontsGuiColor : `#FFFFFF`,
        },
    }),
    logoWrapper: {
        // padding: `0 40px`,
        justifyContent: 'flex-start',
        cursor: "pointer",
        "& > img": {
            height: "100%",
            maxHeight: '40px',
            objectFit: `contain`,
            width: "100%",
            maxWidth: `100%`
        }
    },
    desktopHeaderStart: {
        justifyContent: 'flex-start',
    },
    desktopHeaderEnd: {
        justifyContent: 'flex-end',

    },
    goBackIcon: (props: any) => ({
        "& > svg path": {
            fill: props.isLightGuiColor ? props.fontsGuiColor : `#FFFFFF`,
        }
    })
}));

type Props = {
    openFullScreen: () => void;
    sliderRef: any;
    setPageRangeInUrl: (pageNumber: number) => void;
}

export const ShopperHeader: React.FC<Props> = ({openFullScreen, sliderRef, setPageRangeInUrl}) => {
    const dispatch = useDispatch();
    const {data} = useSelector((state: IAppState) => state.flyersBranch);
    const flyerBasic = useSelector((state: IAppState) => state.flyerBranchBasic.data);
    const isLightGuiColor = tinycolor(flyerBasic?.primaryColorRgb).isLight();
    const fontsGuiColor = flyerBasic?.fontsColorRgb || "#000000";

    const {controlsBranch} = useSelector((state: IAppState) => state);
    const {isFullScreen} = controlsBranch;
    const flyerBranch = useSelector<IAppState, IFlyerRuntime | null>((state) => state.flyersBranch.data);
    const isHebrewStyle = flyerBranch?.dir === "RTL";

    const stylesProperties = {
        fontFamily: data?.font.toLowerCase(),
        direction: data?.dir.toLowerCase(),
        primaryColor: data?.primaryColorRgb ? data?.primaryColorRgb : '#C32E43',
        isLightGuiColor: isLightGuiColor,
        fontsGuiColor: fontsGuiColor
    }
    const classes = useStyles(stylesProperties);
    const resetZooming = () => {
        dispatch(zoomIn({x: 0, y: 0, pivotX: 0, pivotY: 0, scale: 0}));
    }

    const onClickLogo = () => {
        if (flyerBranch?.urls?.accountHomePageUrl) {
            openUrlInAnotherTab(flyerBranch?.urls?.accountHomePageUrl, flyerBranch.caption, "homePage");
        }
    }

    return (
        <Box className={classes.desktopHeaderWrapper} sx={{px: 1, height: '60px', flexGrow: 1}}>
            {isFullScreen && (
                <Grid container alignItems={'center'} sx={{height: `100%`}} columns={24}>
                    <Grid item xs={9} md={10} lg={11} >

                        <Grid container columns={12}>
                            <Grid item xs={2}>
                                <Box className={classes.desktopHeaderBox}>
                                    <Button className={classes.goBackIcon} onClick={() => {
                                        if (document.exitFullscreen) {
                                            document.exitFullscreen();
                                        }
                                        resetZooming();
                                    }}>
                                        {isHebrewStyle ? (
                                            <ChevronRight/>
                                        ) : <ChevronLeft/>}
                                    </Button>
                                </Box>
                            </Grid>
                            <Grid item>
                                <Box
                                    className={`${classes.logoWrapper} ${classes.desktopHeaderBox}`}
                                    title={flyerBranch?.urls?.accountHomePageUrl ? flyerBranch?.urls?.accountHomePageUrl : ''}
                                    onClick={onClickLogo}
                                >
                                    <img src={flyerBranch?.logo} alt="Logo"/>
                                </Box>
                            </Grid>
                            <Grid item sx={{overflow: 'hidden'}}>
                                <Box className={`${classes.desktopHeaderBox} ${classes.desktopHeaderStart}`}>
                                    <Typography fontWeight={700} fontSize={"20px"} sx={{px: 2}}>
                                        {flyerBranch?.caption}
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={6} md={4} lg={2}>
                        <Pagination
                            sliderRef={sliderRef}
                            setPageRangeInUrl={setPageRangeInUrl}
                        />
                    </Grid>
                    <Grid item xs>
                        {/*<Box className={`${classes.desktopHeaderBox} ${classes.desktopHeaderEnd}`}>*/}
                        {/*    <Typography color={`#ffffff`} fontWeight={900} variant={"h1"} sx={{px: 2}}>*/}
                        {/*        XC*/}
                        {/*    </Typography>*/}
                        {/*</Box>*/}
                    </Grid>
                </Grid>
            )}
            {!isFullScreen && (
                <Grid container sx={{height: `100%`}} columns={24}
                      alignItems={'center'} className={classes.desktopHeaderWrapper}>
                    <Grid item xs={7} md={8} xl={9}>
                        <Grid container>
                            <Grid item mx={`15px`}>
                                <Box
                                    className={`${classes.logoWrapper} ${classes.desktopHeaderBox}`}
                                    title={flyerBranch?.urls?.accountHomePageUrl ? flyerBranch?.urls?.accountHomePageUrl : ''}
                                    onClick={onClickLogo}
                                >
                                    {/*<img src={`https://upload.wikimedia.org/wikipedia/commons/thumb/9/97/Logo%21_Logo.svg/640px-Logo%21_Logo.svg.png`} alt="Logo"/>*/}
                                    <img src={flyerBranch?.logo} alt="Logo"/>
                                </Box>
                            </Grid>
                            <Grid item xs sx={{overflow: 'hidden'}}>
                                <Box className={`${classes.desktopHeaderBox} ${classes.desktopHeaderStart}`}
                                     title={flyerBranch?.caption}>
                                    <Typography color={`#ffffff`} fontWeight={700} fontSize={"20px"} sx={{px: 1}}>
                                        {flyerBranch?.caption}
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={10} md={8} xl={6}>
                        <Pagination
                            sliderRef={sliderRef}
                            setPageRangeInUrl={setPageRangeInUrl}
                        />
                    </Grid>
                    <Grid item xs>
                        <Actions openFullScreen={openFullScreen}/>
                    </Grid>
                </Grid>
            )}
        </Box>
    );
}